import { api } from "@api/api";
import { Partner } from "@modules/partners/types";
import { PartnerFormValues } from "@modules/partners/validations";

export async function editPartnerService(
  id: number | string,
  data: Partial<PartnerFormValues>
): Promise<Partner> {
  const { data: partner } = await api.patch<Partner>(
    `/v1/partner_admin/${id}/`,
    data
  );
  return partner;
}
